import React, { useState } from 'react';
import { Document, Page, pdfjs, Outline } from 'react-pdf';

import styles from './AppPDFViewer.module.scss'
import { CustomNextButton, CustomPages, CustomPrevButton } from 'containers/CourseLectures/LectureContent/Navigation/Navigation';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { ReactComponent as In } from "./in.svg";
import { ReactComponent as Out } from "./out.svg";
import { ReactComponent as Restart } from "./restart.svg";
import FlexyPopOnMe from 'elements/flexypoponme';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const AppPDFViewer = ({ url }: { url: string }) => {

  const [scale, setScale] = useState<any>(window.location.pathname.includes('/settings/course') ? 0.75 : 1.0);
  const [numPages, setNumPages] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(1);

  function zoomIn() {
    if (scale <= 1.8) {
      setScale(scale + 0.1);
    }
  }

  function zoomOut() {
    if (scale >= 1.0) {
      setScale(scale - 0.1);
    }
  }

  const [outline, setOutline] = useState(null);

  // @ts-ignore
  function onDocumentLoadSuccess(pdf) {
    setNumPages(pdf.numPages);
    setPageNumber(1);
    pdf.getOutline().then((outline: any) => {
      setOutline(outline);
    });
  }

  // @ts-ignore
  function onItemClick({ pageNumber: itemPageNumber }) {
    setPageNumber(itemPageNumber);
  }

  function changePage(offset: any) {
    // @ts-ignore
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const outlineRef = React.useRef<HTMLDivElement>(null);
  const [outlineIsVisible, set0utlineIsVisible] = React.useState<boolean>(false)

  React.useEffect(() => {
    const closeOptionsDiv = (event: MouseEvent) => {
      if (outlineRef.current && !outlineRef.current.contains(event.target as Node)) {
        set0utlineIsVisible(false);
      }
    };

    document.addEventListener('mousedown', closeOptionsDiv);

    return () => {
      document.removeEventListener('mousedown', closeOptionsDiv);
    };
  }, []);
  const isCourseSettingsPage = window.location.pathname.includes('/settings/course');
  const classNameReader = `${styles.reader} ${isCourseSettingsPage ? styles.readerNoMargin : ''}`;

  return (
    <div className={classNameReader}>
      <div className={styles.readerHeader}>
        <div className={styles.pdfContentWrapper}>
          <CustomPrevButton
            page={pageNumber}
            pages={numPages}
            handlePrevClick={previousPage}
          />
          <CustomPages
            page={pageNumber}
            pages={numPages}
          />
          <CustomNextButton
            page={pageNumber}
            pages={numPages}
            handleNextClick={nextPage} />
        </div>

        <div className={styles.zoomActions}>
          <span
            className={scale === 1.0 ? `${styles.outDisabled}` : `${styles.out}`}
            onClick={() => {
              zoomOut();
            }}
          >
            <Out />
          </span>

          <FlexyPopOnMe
            closeOnComponentClick
            placement='bottom-end'
            component={
              <ul className={styles.ScaleList}>
                <li onClick={() => setScale(1.0)}>Actual size</li>
                <li onClick={() => setScale(0.75)}>Page fit</li>
                <li onClick={() => setScale(1.0)}>100%</li>
                <li onClick={() => setScale(1.25)}>125%</li>
                <li onClick={() => setScale(1.5)}>150%</li>
                <li onClick={() => setScale(1.8)}>180%</li>
              </ul>
            }
          >
            <button onClick={() => { }} className={styles.Scale}>
              {(parseFloat(scale) * 100).toFixed(0)}%
            </button>
          </FlexyPopOnMe>

          <span
            className={scale === 1.3 ? `${styles.inDisabled}` : `${styles.in}`}
            onClick={() => {
              zoomIn();
            }}
          >
            <In />
          </span>
        </div>

        <span
          className={scale === 1.0 ? `${styles.restartDisabled}` : `${styles.restart}`}
          onClick={() => {
            setScale(1.0);
          }}
        >
          <Restart />
        </span>
      </div>
      <div className={styles.readerBody}>
        <div className={styles.readerSideBar}>
          {
            outline !== null &&
            <div
              className={styles.documentOutlineHumbager}
              onClick={() => set0utlineIsVisible(!outlineIsVisible)}
            >
              <div className={styles.Outlines}></div>
              <div className={styles.Outlines}></div>
              <div className={styles.Outlines}></div>
            </div>
          }
        </div>

        <div className={styles.content}>
          <Document
            file={url}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={(
              <div className={styles.LoadingPDF}>
                <p>Loading PDF...</p>
              </div>
            )}
          >
            {
              outlineIsVisible &&
              <div ref={outlineRef}>
                <Outline onItemClick={onItemClick} className={styles.documentOutline} />
              </div>
            }
            <Page pageNumber={pageNumber} scale={scale} />
          </Document>
        </div>
      </div>
    </div>
  )
}

export default AppPDFViewer;